import { render, staticRenderFns } from "./TaggerModalV2.vue?vue&type=template&id=28f1da01"
import script from "./TaggerModalV2.vue?vue&type=script&lang=js"
export * from "./TaggerModalV2.vue?vue&type=script&lang=js"
import style0 from "./TaggerModalV2.vue?vue&type=style&index=0&id=28f1da01&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports